module.exports = __webpack_public_path__ + "img/24775412000162.bd534c73.png";